import React, { useState, useEffect } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { svSE, enUS } from "@mui/x-date-pickers/locales";
import { lngs } from "../../Constant";
import sv from "date-fns/locale/sv";
import en from "date-fns/locale/en-US";
import { useTranslation } from "react-i18next";

export const MyDatePicker = (props) => {
  const { t, i18n } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(props.value ? new Date(props.value) : null);

  const handleDateChange = (date) => {
    // setSelectedDate(date);
    if (date != "Invalid Date") {
      props.onAccept(date);
    } else props.onAccept(null);
  };

  useEffect(() => {
    setSelectedDate(props.value ? new Date(props.value) : null);
  }, [props.value]);

  const className = "mt-3 mb-3 " + props.className;
  const locale = props.locale == lngs.en.code ? enUS : svSE;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      localeText={locale.components.MuiLocalizationProvider.defaultProps.localeText}
      adapterLocale={props.locale == lngs.en.code ? en : sv}
    >
      <DatePicker
        views={props.views ?? null}
        InputProps={{ readOnly: true }}
        className={className}
        inputVariant="outlined"
        placeholder={props.placeholder ? props.placeholder : "ÅÅÅÅ-MM-DD"}
        format="yyyy-MM-dd"
        maxDate={props.maxDate}
        minDate={props.minDate}
        label={props.label}
        size={props.size ? props.size : "medium"}
        slotProps={{
          textField: {
            required: props.required,
            error: props.error,
            placeholder: props.placeholder ? props.placeholder : "ÅÅÅÅ-MM-DD",
            size: props.size ? props.size : "medium",
            style: { width: "100%", ...props.style },
            helperText: props.helperText,
          },
        }}
        closeOnSelect={true}
        value={selectedDate}
        onChange={handleDateChange}
        onAccept={props.onAccept}
        cancelLabel={props.cancelLabel ? props.cancelLabel : "Avbryt"}
        okLabel={props.okLabel ? props.okLabel : "OK"}
      />
    </LocalizationProvider>
  );
};
